export default {
    props: {
        section: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        hasData() {
            return this.section.data
        },
        hasSettings() {
            return this.section && this.section.settings 
                ? this.section.settings 
                : false
        },
        container() {
            const container = this.hasSettings && this.hasSettings.container
            return container && container != 'none' 
                ? `container-${container}` 
                : 'no-container'
        },
        padding() {
            const padding = this.hasSettings && this.hasSettings.padding
            return padding && (padding.y != 0 || padding.x != 0)
                ? `${padding.y}px ${padding.x}px`
                : ''
        },
        margin() {
            const margin = this.hasSettings && this.hasSettings.margin
            return margin && (margin.y != 0 || margin.x != 0)
                ? `${margin.y}px ${margin.x}px`
                : ''
        },
        background() {
            const background = this.hasSettings && this.hasSettings.color
            return background && background.alpha >= 0.1
                ? `hsla(${background.hue}, ${background.saturation}%, ${background.luminosity}%, ${background.alpha})`
                : ''
        },
        box() {
            return {
                background: this.background,
                padding: this.padding,
                margin: this.margin,
            }
        }
    }
}